<template>
  <!---->
  <div v-if="showCard">

    <v-card style="z-index: 1; position:fixed; bottom:0px; right:0px;" color="red darken-4" elevation="6" class="pa-1 mb-2 mr-1" v-if="$vuetify.breakpoint.xsOnly">
      <p class="caption font-weight-bold text-center white--text mb-2">Post news and personalize your feed</p>
      <v-row class="ma-0 pa-0">
        <v-col cols="10" class="ma-0 pa-0 pb-3 pl-4 pr-4">
          <!-- <v-btn class="success font-weight-bold " block to="login">
            {{ $t("Login") }}
          </v-btn> -->
          <v-btn block  to="register" small>
            {{ $t("Sign up") }}
          </v-btn>
        </v-col>

        <!--Optional close button-->
        <v-col cols="1" class=" pa-0">
          <v-btn icon small color="white" @click="showCard = !showCard">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>

      </v-row>
    </v-card>

    <v-card style="z-index: 1; position:fixed; bottom:0px; right:0px;" color="red darken-4" class="pa-3 mb-2" v-else>
      <!-- <p class="headline font-weight-bold text-center white--text">{{ $t("Welcome to WeNewz") }}</p> -->
      <p class="headline font-weight-bold text-center white--text mb-2">Post news and personalize your feed</p>
      <v-row class="ma-0 pa-0">
        <!-- <v-col md12 class="ma-0 pa-0 pb-3">
          <v-btn class="success font-weight-bold title" block to="login">
            {{ $t("Login") }}
          </v-btn>
        </v-col> -->
        <v-col cols="10" class="ma-0 pa-0">
          <v-btn block class="title" to="register">
          {{ $t("Sign up") }}
          </v-btn>
        </v-col>

        <!--Optional close button-->
        <v-col cols="2" class="ma-0 pa-0">
          <v-btn color="error" @click="showCard = !showCard">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>

      </v-row>
    </v-card>
  </div>
</template>


<script>
// Import the i18n export file
import messages from "../../../modules/lang/main/export";
export default {
  // Use it in this file
  i18n: { messages },
  data(){
    return{
        showCard: true,
    }
  }
}
</script>
